import { createSlice } from '@reduxjs/toolkit';
import { pushDynamicTab } from '../utils/dynamicTabs';

// 🔹 Define the current version of the slice
const SLICE_VERSION = '1.0';

// 🔹 Export the initial state so it can be imported in store.js
export const initialState = {
  _version: SLICE_VERSION,
  defaultTabs: [
    { id: 'my-messages', name: 'My Messages' },
    { id: 'customer-messages', name: 'Customer Messages' },
    { id: 'templates', name: 'Templates' },
    { id: 'drafts', name: 'Drafts' },
    { id: 'check', name: 'Checks' },
    { id: 'deleted-messages', name: 'Deleted' },
  ],
  dynamicTabs: [],
  activeTab: 0,
  selectedTemplate: null,
};

// 🔹 Create the slice
const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    addTab: (state) => {
      const dynamicId = window.crypto?.randomUUID?.() ?? 
        `${Date.now()}-${Math.random().toString(36).slice(2, 15)}-${state.dynamicTabs.length}`;

      pushDynamicTab(
        state,
        {
          id: `dyn-${dynamicId}`,
          name: `New Messages ${state.dynamicTabs.length + 1}`,
          isDynamic: true,
          createdAt: Date.now(),
        },
        state.defaultTabs.length
      );
    },

    removeTab: (state, action) => {
      const { tabIndex } = action.payload;
      if (tabIndex < state.defaultTabs.length) return;

      const dynamicIndex = tabIndex - state.defaultTabs.length;
      state.dynamicTabs.splice(dynamicIndex, 1);

      state.activeTab = Math.min(
        state.activeTab,
        state.defaultTabs.length + state.dynamicTabs.length - 1
      );
    },

    setActiveTab: (state, action) => {
      const { index } = action.payload;
      const totalTabs = state.defaultTabs.length + state.dynamicTabs.length;
      if (index >= 0 && index < totalTabs) {
        state.activeTab = index;
      }
    },

    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },

    resetTabs: (state) => {
      state.dynamicTabs = [];
      state.activeTab = 0;
    },
  },
});

// 🔹 Export actions and reducer
export const { addTab, removeTab, setActiveTab, setSelectedTemplate, resetTabs } =
  messagesSlice.actions;

export default messagesSlice.reducer;
